export const SEO_CATEGORY_MAP = {
  "NA==": true,
  "Ng==": true,
  "Nw==": true,
  "MTI=": true,
  "MzQ=": true,
  "OA==": true,
  "MTM=": true,
  "MTY=": true,
  "MTY3": true,
  "MTcy": true,
  "MTQ=": true,
  "NTQ=": true,
  "Njk=": true,
  "ODI=": true,
  "OTQ=": true,
  "OTk=": true,
  "NDU=": true,
  "MTEx": true,
};


